(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sonko-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const guides = [...root.querySelectorAll('[data-guide]')];
    const cards = [...root.querySelectorAll('[data-article-target]')];

    function showGuide(target) {
      for (const guide of guides) guide.hidden = guide.dataset.guide !== target;
      for (const card of cards) {
        const selected = card.dataset.articleTarget === target;
        card.classList.toggle('active', selected);
        card.setAttribute('aria-pressed', String(selected));
      }
    }

    for (const guide of guides) {
      const toc = guide.querySelector('.article-toc');
      const details = document.createElement('details');
      details.open = matchMedia('(min-width:741px)').matches;
      const summary = document.createElement('summary');
      summary.textContent = toc.getAttribute('aria-label');
      const links = document.createElement('div');
      links.className = 'toc-links';
      const headings = guide.querySelectorAll('.article-body h2, .article-body h3');
      headings.forEach((heading, index) => {
        heading.id ||= guide.id + '-section-' + (index + 1);
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.className = 'sub';
        links.append(link);
      });
      details.append(summary, links);
      toc.append(details);
    }

    for (const card of cards) {
      card.addEventListener('click', () => {
        showGuide(card.dataset.articleTarget);
        root.querySelector('#sonko-article-' + card.dataset.articleTarget).scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }
    const hash = location.hash.slice(1);
    const selected = guides.find(guide => hash === guide.id || hash.startsWith(guide.id + '-section-'));
    showGuide((selected || guides[0]).dataset.guide);
  }

  const initialize = () => document.querySelectorAll('[data-sonko-journal]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonko-luggage-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sonko-luggage')) {
  customElements.define('sonko-luggage', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.series = 'all';
      this.size = 'all';
      this.cards = [...this.querySelectorAll('.sk-product')];
      this.status = this.querySelector('.sk-filter-status');
      this.empty = this.querySelector('.sk-empty');
      this.addEventListener('click', event => {
        const filter = event.target.closest('button[data-filter]');
        if (filter && this.contains(filter)) {
          this[filter.dataset.filter] = filter.dataset.value;
          this.updateProducts();
        }
        if (event.target.closest('[data-reset]')) {
          this.series = 'all';
          this.size = 'all';
          this.updateProducts();
          this.querySelector('[data-filter="series"][data-value="all"]')?.focus();
        }
      });
      this.classList.add('is-ready');
      this.updateProducts();
      const choices = [...this.querySelectorAll('[data-compare-size]')];
      const pairs = [...this.querySelectorAll('[data-pair]')];
      const showPair = size => {
        for (const choice of choices) choice.setAttribute('aria-pressed', String(choice.dataset.compareSize === size));
        for (const pair of pairs) pair.hidden = pair.dataset.pair !== size;
      };
      for (const pair of pairs) {
        const settings = pair.querySelector('.sk-wipe-settings');
        const angle = pair.querySelector('[data-compare-angle]');
        const colors = [...pair.querySelectorAll('[data-compare-color]')];
        const updatePhotos = () => {
          for (const select of colors) {
            const image = pair.querySelector('.sk-wipe-' + select.dataset.compareColor);
            const url = select.selectedOptions[0].dataset[angle.value];
            if (image.src !== url) {
              image.removeAttribute('srcset');
              image.src = url;
            }
            image.alt = (select.dataset.compareColor === 'macarons' ? '馬卡龍' : 'NoMAD') +
              ' ' + pair.dataset.pair + ' 吋 ' + select.value + ' · ' + angle.selectedOptions[0].text;
          }
          pair.dataset.angle = angle.value;
        };
        settings.hidden = false;
        settings.addEventListener('change', updatePhotos);
        const range = pair.querySelector('[data-wipe]');
        if (!range) continue;
        const stage = range.parentElement;
        const syncSplit = () => stage.style.setProperty('--split', range.value + '%');
        const desktop = matchMedia('(min-width:700px)');
        range.addEventListener('input', syncSplit);
        stage.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse' || !desktop.matches) return;
          const bounds = stage.getBoundingClientRect();
          if (!bounds.width) return;
          const percent = (event.clientX - bounds.left) / bounds.width * 100;
          range.value = String(Math.round(Math.max(0, Math.min(100, percent))));
          syncSplit();
        });
      }
      if (choices.length) {
        this.querySelector('.sk-compare-options').hidden = false;
        for (const choice of choices) choice.addEventListener('click', () => showPair(choice.dataset.compareSize));
        showPair('24');
      }
      if ('IntersectionObserver' in window && matchMedia('(min-width:900px) and (prefers-reduced-motion:no-preference)').matches) {
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.isIntersecting) {
            entry.target.classList.add('sk-revealed');
            observer.unobserve(entry.target);
          }
        }, {threshold:.13});
        this.querySelectorAll('.sk-section-head,.sk-series-grid,.sk-visit,.sk-size-panels,.sk-faq-list').forEach(node => observer.observe(node));
      }
    }
    updateProducts() {
      let count = 0;
      for (const card of this.cards) {
        const visible = (this.series === 'all' || card.dataset.series === this.series) &&
          (this.size === 'all' || card.dataset.size === this.size);
        card.hidden = !visible;
        if (visible) count++;
      }
      for (const button of this.querySelectorAll('[data-filter]')) {
        button.setAttribute('aria-pressed', String(this[button.dataset.filter] === button.dataset.value));
      }
      if (this.status) this.status.textContent = this.status.dataset.statusTemplate.replace('{count}', count);
      if (this.empty) this.empty.hidden = count !== 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
